export default "__VITE_ASSET__BxpXgKG6__"